<template>
  <div class="comments" v-if="payload">

    <span class="tooltip" v-if="!commenters || commenters.length <= 0">
      <span class="tooltiptext">comments</span>
    </span>

    <team-member-avatar :subject="commenter" height="50px" width="50px" v-for="commenter in commenters" :key="comment.id"></team-member-avatar>

    <router-link :to="'/a/document/' + payload.id + '/comments'" class="button show-comments"><span><i class="icon icon-chat"></i></span></router-link>
  </div>
</template>

<script>
  export default {
    props: ['payload'],
    computed: {
      commenters() {
        let commenters = [];

        if (this.payload && this.payload.comments && Array.isArray(this.payload.comments)) {
          commenters = _.uniq(_.map(this.payload.comments, function(comment) {
            return comment.commenter;
          }), function(commenter) {
            return commenter.name;
          });
        }

        return commenters;
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "resources/assets/sass/layout/_variables";

  .comments {
    position:fixed;
    left: 20px;
    bottom: 20px;
    display: flex;
    flex-direction: column;
    width: 50px;
    .tooltip {
      position: relative;
      display: inline-block;
      margin-bottom: 15px;
      opacity: 0.8;
      -webkit-transition: all .3s ease;
      -moz-transition: all .3s ease;
      -ms-transition: all .3s ease;
      -o-transition: all .3s ease;
      transition: all .3s ease;
      .tooltiptext {
        font-size: 10px;
        text-transform: uppercase;
        letter-spacing: 1px;
        box-shadow: 0 2px 13px 1px rgba(211, 215, 221, 0.5);
        width: 74px;
        top: 100%;
        left: 43%;
        margin-left: -37px;
        background-color: $white;
        color: darken($mutedblue, 10%);
        text-align: center;
        padding: 5px 0;
        border-radius: 4px;
        position: absolute;
        z-index: 1;
        &::after {
          content: " ";
          position: absolute;
          top: 100%;
          left: 50%;
          margin-left: -5px;
          border-width: 5px;
          border-style: solid;
          border-color: $white transparent transparent transparent;
        }
      }
    }
    .team-member-circle-wrapper {
      margin-bottom: -10px;
    }
    .show-comments {
      margin-top: 25px;
      background: $white;
      box-shadow: 0 2px 13px 1px rgba(211,215,221,0.50);
      border-radius: 100px;
      border-color: $white;
      width: 50px;
      height: 50px;
      color: $mutedblue;
      border: 1px solid $mutedblue;
      &:hover {
        border-color: $green;
        color: $green;
      }
    }
    &:hover {
      .tooltip {
        margin-bottom: 20px;
        opacity: 1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// comments-float.vue?a0f91a78